// extracted by mini-css-extract-plugin
export var productImage = "_q9-1";
export var viewLink = "_q9-2";
export var wishlistItem = "_q9-0";